import { aiWritingToolChildPageRequestParams } from 'strapi/page/aiWritingToolChildPage/builder';
import { aiWritingToolParentPageRequestParams } from 'strapi/page/aiWritingToolParentPage/builder';
import { createLibraryPageRequestParams } from 'strapi/page/createLibraryPage/builder';
import { createSubUseCasePageRequestParams } from 'strapi/page/createSubUseCasePage/builder';
import { createUseCasePageRequestParams } from 'strapi/page/createUseCasePage/builder';
import { mockupChildPageRequestParams } from 'strapi/page/mockupChildPage/builder';
import { mockupParentPageRequestParams } from 'strapi/page/mockupParentPage/builder';
import { templatesUseCasePageRequestParams } from 'strapi/page/templatesUseCasePage/builder';
import { toolsLibraryPageRequestParams } from 'strapi/page/toolsLibraryPage/builder';
import { PageType, PageTypes } from 'strapi/page/types';
import { RequestParams, StrapiFilter } from 'strapi/types';

// Those build functions define what fields we need to populate
// in each page by page type. The components populate functions are
// in the components builder and should be omitted here.
export const pageRequestParams: Record<
  PageType,
  (filter: StrapiFilter) => RequestParams<PageTypes>
> = {
  [PageType.CreateLibraryPage]: createLibraryPageRequestParams,
  [PageType.CreateUseCasePage]: createUseCasePageRequestParams,
  [PageType.CreateSubUseCasePage]: createSubUseCasePageRequestParams,
  [PageType.TemplatesUseCasePage]: templatesUseCasePageRequestParams,
  [PageType.TemplatesSubUseCasePage]: createSubUseCasePageRequestParams,
  [PageType.MockupParentPage]: mockupParentPageRequestParams,
  [PageType.MockupChildPage]: mockupChildPageRequestParams,
  [PageType.AiWritingToolParentPage]: aiWritingToolParentPageRequestParams,
  [PageType.AiWritingToolChildPage]: aiWritingToolChildPageRequestParams,
  [PageType.ToolsLibraryPage]: toolsLibraryPageRequestParams,
};
